/* eslint-disable no-unused-expressions */
/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable radix */
/* eslint-disable prefer-template */
/* eslint-disable eqeqeq */
/* eslint-disable prefer-const */
/* eslint-disable semi */
/* eslint-disable arrow-parens */
const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');//翻译用
const blockIconURI = require('./weather-logo.svg');
// const menuIconURI = blockIconURI;

// const valueDelay = valueDelayPromise.bind(aixiongBlocks)

class weatherBlocks {
    constructor(runtime) {
        /**
         * The runtime instantiating this block package.
         * @type {Runtime}
         */
        this.runtime = runtime;
        // console.log('this.runtime --> ', runtime)

        if (this.runtime.ioDevices) {
            this.ioDevices = this.runtime.ioDevices
            this.Aixiong = this.ioDevices.Aixiong
            this.runMode = this.Aixiong.runMode
            // this.socket = this.Aixiong.socket
            this.adaptor = this.Aixiong.adaptor
            this.running = false
            console.log('this.ioDevices --> ', this.ioDevices)
        }
        this.getAccessToken = () => {
            let _search = location.search;
            location._query = {};
            location._query['lang'] = 'en';
            let queryArray = [];
            if (_search) {
                _search = _search.replace('?', '');
                queryArray = _search.split('&');
                for (var i = 0; i < queryArray.length; i++) {
                    location._query[queryArray[i].split('=')[0]] = queryArray[i].split('=')[1];
                }
            }
            let accessToken = location._query['accessToken'];
            let domain = location._query['domain'] || 'https://coursedev.e-ai-edu.com';
            return {
                accessToken,
                domain
            }
        };
        this.domain = this.getAccessToken().domain;
        this.accessToken = this.getAccessToken().accessToken;

        this.nowyear = new Date().getFullYear();
        this.nowmonth = new Date().getMonth() + 1;
        this.nowday = new Date().getDate()-1;
        this.nowtime = new Date().getHours();

    }

    /**
     * The key to load & store a target's test-related state.
     * @type {string}
     */
    static get STATE_KEY() {
        return 'Scratch.weather';
    }

    /**
     * @returns {object} metadata for this extension and its blocks.
     */
    getInfo() {
        return {
            // 详细介绍：https://github.com/LLK/scratch-vm/blob/develop/docs/extensions.md
            // Required: the machine-readable name of this extension.
            // Will be used as the extension's namespace.
            id: 'weather',
            name: '天气数据',
            // Optional: URI for an icon to be displayed in the blocks category menu.
            menuIconURI: blockIconURI, //menuIconURI,
            // Optional: URI for a block icon, to display at the edge of each block for this
            blockIconURI: blockIconURI,
            color1: '#29BEAF',
            // Optional: Link to documentation content for this extension.
            // If not present, offer no link.
            // docsURI: 'https://....',
            // 插件右上角的硬件连接状态显示按钮
            showStatusButton: false,
            blocks: [
                {
                    opcode: 'realTimeWeather',
                    text: '实时天气 [city] [weatherType]',
                    blockType: BlockType.REPORTER,
                    arguments: {
                        city: {
                            type: ArgumentType.STRING,
                            defaultValue: '北京',
                        },
                        weatherType: {
                            type: ArgumentType.STRING,
                            menu: 'weatherTypeArr',
                            defaultValue: 'weather'
                        }
                    }
                },
                {
                    opcode: 'airQuality',
                    text: '实时天气 [acity] [airQualityType]',
                    blockType: BlockType.REPORTER,
                    arguments: {
                        acity: {
                            type: ArgumentType.STRING,
                            defaultValue: '北京',
                        },
                        airQualityType: {
                            type: ArgumentType.STRING,
                            menu: 'airQualityType',
                            defaultValue: 'quality'
                        }
                    }
                },
                {
                    opcode: 'weatherForecast',
                    text: '天气预报 [wcity] [cycleDay] [forecastType]',
                    blockType: BlockType.REPORTER,
                    arguments: {
                        wcity: {
                            type: ArgumentType.STRING,
                            defaultValue: '北京',
                        },
                        cycleDay: {
                            type: ArgumentType.STRING,
                            menu: 'cycleDayType',
                            defaultValue: 1
                        },
                        forecastType: {
                            type: ArgumentType.STRING,
                            menu: 'forecastType',
                            defaultValue: 'day_weather'
                        }
                    }
                },
                // {
                //     opcode: 'hourseForecast',
                //     text: '二十四小时预报[fcity] 时间[time] [hourseForecastType]',
                //     blockType: BlockType.REPORTER,
                //     arguments: {
                //         fcity: {
                //             type: ArgumentType.STRING,
                //             defaultValue: '北京',
                //         },
                //         time: {
                //             type: ArgumentType.STRING,
                //             defaultValue: this.nowtime
                //         },
                //         hourseForecastType: {
                //             type: ArgumentType.STRING,
                //             menu: 'hourseForecastType',
                //             defaultValue: 'weather'
                //         }
                //     }
                // },
                {
                    opcode: 'historicalWeather',
                    text: "历史天气[hcity] [year][month][day] [historicalForecast]",
                    blockType: BlockType.REPORTER,
                    arguments: {
                        hcity: {
                            type: ArgumentType.STRING,
                            defaultValue: '北京',
                        },
                        year: {
                            type: ArgumentType.STRING,
                            defaultValue: this.nowyear,
                        },
                        month: {
                            type: ArgumentType.STRING,
                            defaultValue: this.nowmonth,
                        },
                        day: {
                            type: ArgumentType.STRING,
                            defaultValue: this.nowday,
                        },
                        historicalForecast: {
                            type: ArgumentType.STRING,
                            menu: 'historicalForecastType',
                            defaultValue: ''
                        }
                    }
                },
            ],

            menus: {
                weatherTypeArr: [
                    { text: '天气', value: 'weather' },
                    { text: '温度', value: 'temperature' },
                    { text: '湿度', value: 'sd' },
                    { text: '风向', value: 'wind_direction' },
                    { text: '风力', value: 'wind_power' },
                ],
                airQualityType: [
                    { text: '空气质量', value: 'quality' },
                    { text: 'AQI', value: 'aqi' },
                    { text: 'PM2.5', value: 'pm2_5' },
                    { text: 'PM10', value: 'pm10' },
                    { text: 'CO', value: 'co' },
                    { text: 'NO2', value: 'no2' },
                    { text: 'O3', value: 'o3' },
                    { text: 'O3_8h', value: 'o3_8h' },
                    { text: 'SO2', value: 'so2' },
                ],
                cycleDayType: [
                    { text: '今天', value: 1 },
                    { text: '明天', value: 2 },
                    { text: '后天', value: 3 },
                    { text: 'Day4', value: 4 },
                    { text: 'Day5', value: 5 },
                    { text: 'Day6', value: 6 },
                    { text: 'Day7', value: 7 },
                ],
                forecastType: [
                    { text: '白天天气', value: 'day_weather' },
                    { text: '白天温度', value: 'day_air_temperature' },
                    { text: '白天风向', value: 'day_wind_direction' },
                    { text: '白天风力', value: 'day_wind_power' },
                    { text: '夜间天气', value: 'night_weather' },
                    { text: '夜间温度', value: 'night_air_temperature' },
                    { text: '夜间风向', value: 'night_wind_direction' },
                    { text: '夜间风力', value: 'night_wind_power' },
                    { text: '降水概率', value: 'jiangshui' },
                    { text: '日出时间', value: 'sun_begin' },
                    { text: '日落时间', value: 'sun_end' },
                    { text: '紫外线强度', value: 'ziwaixian' },
                ],
                hourseForecastType: [
                    { text: '天气', value: 'weather' },
                    { text: '温度', value: 'temperature' },
                    { text: '风向', value: 'wind_direction' },
                    { text: '风力', value: 'wind_power' },
                ],
                historicalForecastType: [
                    { text: '天气', value: 'weather' },
                    { text: '最高气温', value: 'max_temperature' },
                    { text: '最低气温', value: 'min_temperature' },
                    { text: '风向', value: 'wind_direction' },
                    { text: '风力', value: 'wind_power' },
                    { text: '空气质量', value: 'aqiInfo' },
                    { text: 'AQI', value: 'aqi' },
                ]
            }
        };
    }

    /**
     * TODO 这个是摘取过来的，作用还没有彻底搞明白。
     * Retrieve the block primitives implemented by this package.
     * @return {object.<string, Function>} Mapping of opcode to Function.
     */


    realTimeWeather(args) {
        return new Promise(resolve => {
            fetch(`${this.domain}/api/ali_markets/areaToWeather?access_token=${this.accessToken}&area=${args.city}`, {
                headers: {
                    'content-type': 'application/json'
                },
                method: 'GET'
            }).then(res => res.json()).then(ret => {
                if (ret.showapi_res_body) {
                    let result = '';
                    let nowWeather = ret.showapi_res_body.now;
                    if (args.weatherType == 'weather') {
                        result = nowWeather.weather
                    } else if (args.weatherType == 'temperature') {
                        result = nowWeather.temperature ? nowWeather.temperature + '℃' : '';
                    } else if (args.weatherType == 'sd') {
                        result = nowWeather.sd
                    } else if (args.weatherType == 'wind_direction') {
                        result = nowWeather.wind_direction
                    } else if (args.weatherType == 'wind_power') {
                        result = nowWeather.wind_power
                    } else {
                        result = ''
                    }
                    resolve(result)
                } else {
                    if (ret.error) {
                        resolve(ret.error.message)
                    } else {
                        resolve("网络错误！")
                    }
                }
            });
        });
    };
    airQuality(args) {
        return new Promise(resolve => {
            fetch(`${this.domain}/api/ali_markets/areaToWeather?access_token=${this.accessToken}&area=${args.acity}`, {
                headers: {
                    'content-type': 'application/json'
                },
                method: 'GET'
            }).then(res => res.json()).then(ret => {
                if (ret.showapi_res_body) {
                    let result = '';
                    let aqiDetail = ret.showapi_res_body.now.aqiDetail;
                    console.log("wq",aqiDetail)
                    if (args.airQualityType == 'quality') {
                        result = aqiDetail.quality;
                    } else if (args.airQualityType == 'aqi') {
                        result = aqiDetail.aqi;
                    } else if (args.airQualityType == 'pm2_5') {
                        result = aqiDetail.pm2_5
                    } else if (args.airQualityType == 'pm10') {
                        result = aqiDetail.pm10
                    } else if (args.airQualityType == 'co') {
                        result = aqiDetail.co
                    } else if (args.airQualityType == 'no2') {
                        result = aqiDetail.no2
                    } else if (args.airQualityType == 'o3') {
                        result = aqiDetail.o3
                    } else if (args.airQualityType == 'o3_8h') {
                        result = aqiDetail.o3_8h
                    } else if (args.airQualityType == 'so2') {
                        result = aqiDetail.so2
                    } else {
                        result = ''
                    }
                    resolve(result)
                } else {
                    if (ret.error) {
                        resolve(ret.error.message)
                    } else {
                        resolve("网络错误！")
                    }
                }
            });
        });
    };
    weatherForecast(args) {
        let currentTime = new Date();
        let currentYear = currentTime.getFullYear();
        let currentMonth = currentTime.getMonth() + 1 < 10 ? '0' + (currentTime.getMonth() + 1) : currentTime.getMonth() + 1;
        let currentDay = currentTime.getDate();
        if (args.cycleDay) {
            let num = parseFloat(args.cycleDay);
            let day=(currentDay + num - 1)<10?'0'+(currentDay + num - 1):(currentDay + num - 1);
            currentDay = day
        }
        let currentDate = '' + currentYear + currentMonth + currentDay;
        return new Promise(resolve => {
            fetch(`${this.domain}/api/ali_markets/areaToWeatherDate?access_token=${this.accessToken}&area=${args.wcity}&date=${currentDate}`, {
                headers: {
                    'content-type': 'application/json'
                },
                method: 'GET'
            }).then(res => res.json()).then(ret => {
                if (ret.showapi_res_body) {
                    let result = '';
                    let oneF = `f${args.cycleDay}`;
                    let resDetail = ret.showapi_res_body[oneF];
                    let sunTime = resDetail ? resDetail.sun_begin_end : '';
                    let sunTimeArr = sunTime.split('|');
                    if (args.forecastType == 'day_weather') {
                        result = resDetail.day_weather;
                    } else if (args.forecastType == 'day_air_temperature') {
                        result = resDetail.day_air_temperature ? resDetail.day_air_temperature + '℃' : '';
                    } else if (args.forecastType == 'day_wind_direction') {
                        result = resDetail.day_wind_direction;
                    } else if (args.forecastType == 'day_wind_power') {
                        result = resDetail.day_wind_power;
                    } else if (args.forecastType == 'night_weather') {
                        result = resDetail.night_weather;
                    } else if (args.forecastType == 'night_air_temperature') {
                        result = resDetail.night_air_temperature ? resDetail.night_air_temperature + '℃' : '';
                    } else if (args.forecastType == 'night_wind_direction') {
                        result = resDetail.night_wind_direction;
                    } else if (args.forecastType == 'night_wind_power') {
                        result = resDetail.night_wind_power;
                    } else if (args.forecastType == 'jiangshui') {
                        result = resDetail.jiangshui
                    } else if (args.forecastType == 'sun_begin') {
                        result = sunTimeArr[0] && sunTimeArr[0];
                    } else if (args.forecastType == 'sun_end') {
                        result = sunTimeArr[1] && sunTimeArr[1];
                    } else if (args.forecastType == 'ziwaixian') {
                        result = resDetail.ziwaixian;
                    } else {
                        result = ''
                    }
                    resolve(result)
                } else {
                    if (ret.error) {
                        resolve(ret.error.message)
                    } else {
                        resolve("网络错误！")
                    }
                }
            });
        });
    };
    hourseForecast(args) {
        return new Promise(resolve => {
            fetch(`${this.domain}/api/ali_markets/hour24?access_token=${this.accessToken}&area=${args.fcity}`, {
                headers: {
                    'content-type': 'application/json'
                },
                method: 'GET'
            }).then(res => res.json()).then(ret => {
                // console.log("chenghsi", ret)
                if (ret.showapi_res_body) {
                    let result = '';
                    let hourList = ret.showapi_res_body.hourList;
                    let item = hourList[args.time];
                    if (!item) {
                        resolve('请输入正确的时间格式！');
                        return
                    }
                    if (args.hourseForecastType == 'weather') {
                        result = item.weather;
                    } else if (args.hourseForecastType == 'temperature') {
                        result = item.temperature ? item.temperature + '℃' : '';
                    } else if (args.hourseForecastType == 'wind_direction') {
                        result = item.wind_direction;
                    } else if (args.hourseForecastType == 'wind_power') {
                        result = item.wind_power;
                    } else {
                        result = ''
                    }
                    resolve(result)
                } else {
                    if (ret.error) {
                        resolve(ret.error.message)
                    } else {
                        resolve("网络错误！")
                    }
                }
            });
        });
    };
    historicalWeather(args) {
        let currentYear = args.year;
        let currentMonth = args.month>=10?args.month:'0'+args.month;
        let currentDay = args.day;
        let currentDate = '' + currentYear + currentMonth;
        return new Promise(resolve => {
            fetch(`${this.domain}/api/ali_markets/weatherhistory?access_token=${this.accessToken}&area=${args.hcity}&month=${currentDate}`, {
                headers: {
                    'content-type': 'application/json'
                },
                method: 'GET'
            }).then(res => res.json()).then(ret => {
                if (ret.showapi_res_body) {
                    let result = '';
                    let list = ret.showapi_res_body.list ? ret.showapi_res_body.list : [];
                    let item = list[currentDay - 1];
                    if (!item) {
                        resolve("请输入正确的时间！");
                        return
                    }
                    if (args.historicalForecast == 'weather') {
                        result = item.weather;
                    } else if (args.historicalForecast == 'max_temperature') {
                        result = item.max_temperature ? item.max_temperature + '℃' : '';
                    } else if (args.historicalForecast == 'min_temperature') {
                        result = item.min_temperature ? item.min_temperature + '℃' : '';
                    } else if (args.historicalForecast == 'wind_direction') {
                        result = item.wind_direction;
                    } else if (args.historicalForecast == 'wind_power') {
                        result = item.wind_power;
                    } else if (args.forecastType == 'aqiInfo') {
                        result = item.aqiInfo;
                    } else if (args.forecastType == 'aqi') {
                        result = item.aqi;
                    } else {
                        result = ''
                    }
                    resolve(result)
                } else {
                    if (ret.error) {
                        resolve(ret.error.message)
                    } else {
                        resolve("网络错误！")
                    }
                }
            });
        });
    }
}

module.exports = weatherBlocks;
